export const typography = {
  fontFamily: {
    regular: 'TWKLausanne-450',
    bold: 'TWKLausanne-550'
  },
}
